/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ModalChamoso from '@chama/ui-components/components/ModalChamoso';
import LoadingOverlay from '@chama/ui-components/components/LoadingOverlay';

import AddProductForm from './AddProductForm';
import BrandInput from '../Inputs/ProductsFormBrandInput';
import PriceInput from '../Inputs/ProductsFormPriceInput';
import ProductsFormErrors from '../ProductsFormErrors';
import AddProductFormActions from './AddProductFormActions';

import './ProductsAddProductForm.css';

export default function ProductsAddProductForm({
  onHideAddProductForm,
  onAddDealerProduct,
  brandsAvailableToAdd,
}) {
  return (
    <ModalChamoso type="happy" onClose={onHideAddProductForm}>
      <AddProductForm
        brandsAvailableToAdd={brandsAvailableToAdd}
        onAddDealerProduct={onAddDealerProduct}
        onHideAddProductForm={onHideAddProductForm}
      >
        {formikProps => {
          const { errors } = formikProps;
          const isSavingDisabled = Object.keys(errors).length > 0;
          return (
            <div className="DealerProductsAddProductForm">
              {formikProps.isSubmitting && <LoadingOverlay />}
              <h2 className="DealerProductsAddProductForm__title">
                <FormattedMessage id="add_product_title" />
              </h2>
              <div className="DealerProductsAddProductForm__form-group">
                <label htmlFor="brand">
                  <FormattedMessage id="brand" />
                </label>
                <BrandInput
                  brands={brandsAvailableToAdd}
                  name="brand"
                  errored={'brand' in errors}
                />
              </div>
              <div className="DealerProductsAddProductForm__form-group">
                <label htmlFor="price">
                  <FormattedMessage id="price" />
                </label>
                <PriceInput name="price" disabled={false} errored={'price' in errors} />
              </div>
              <ProductsFormErrors errors={errors} />
              <AddProductFormActions
                onResetForm={formikProps.resetForm}
                onSubmitForm={formikProps.submitForm}
                onHideAddProductForm={onHideAddProductForm}
                isSavingDisabled={isSavingDisabled}
              />
            </div>
          );
        }}
      </AddProductForm>
    </ModalChamoso>
  );
}
ProductsAddProductForm.propTypes = {
  onHideAddProductForm: PropTypes.func.isRequired,
  onAddDealerProduct: PropTypes.func.isRequired,
  brandsAvailableToAdd: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsAddProductForm/ProductsAddProductForm.jsx